<!-- 编辑套包设置 -->
<template>
<div class="business-content-main" v-loading="searchApParams._visible" element-loading-spinner="none">
    <div style="margin-right: 80px">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section-title" style="margin-top: 22px">
            <div>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch(true)" v-if="type == 0">选择组包商品</el-button>
                <el-button size="small" class="btn-primary search-btn" @click="submitForm()" v-if="type != 1">保存套包设置</el-button>
            </div>
        </div>
        <div class="search-ctn" style="padding-top: 22px">
            <el-form ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content">
                            <el-form-item label="包名称" prop="EntpCusName">
                                <el-input style="width: 100%" disabled v-model="submitData.GoodName" :title="submitData.GoodName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content">
                            <el-form-item label="包编码" prop="ShipType">
                                <el-input style="width: 100%" disabled v-model="submitData.APCode" :title="submitData.APCode"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content">
                            <el-form-item label="适用车型" prop="OrderSale">
                                <el-input style="width: 100%" disabled v-model="submitData.AutoSerise" :title="submitData.AutoSerise"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!--    table    -->
        <div class="section-title">
            <div>
                套包商品明细
                <span style="font-size: 14px; margin-left: 10px; color: red">（
                    温馨提醒：明细中不能再选择主包商品哟！）</span>
            </div>
            <div>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch(false)" v-if="!dataReadonly">搜索配件(F2)</el-button>
            </div>
        </div>
        <div class="edit-ctn">
            <!--      table title      -->
            <div @click="hideMsg()" class="div-table-row table-title">
                <div class="div-table-cell" style="width: 15%; flex-grow: 1">
                    <span class="color-red">*</span>汽配编码
                </div>
                <div class="div-table-cell" style="width: 20%">
                    <span class="color-red">*</span>配件名称
                </div>
                <div class="div-table-cell" style="width: 25%">
                    <span class="color-red">*</span>车型
                </div>
                <div class="div-table-cell" style="width: 10%">单包数量</div>
                <div class="div-table-cell" style="width: 10%">
                    <span class="color-red">*</span>单位
                </div>
                <div class="div-table-cell" style="width: 10%">成本价</div>
                <div class="div-table-cell" style="width: 10%">当前库存</div>
            </div>
        </div>
    </div>
    <!-- table body -->
    <div id="infinite-list" class="infinite-list" :style="{ height: infiniteListHeight + 'px' }" v-infinite-scroll="loadDownScroll" infinite-scroll-distance="10" :infinite-scroll-immediate="false">
        <div class="edit-ctn">
            <div @click="hideMsg()" class="table-main">
                <div v-for="(item, index) in dataList" :key="index" style="margin-right: 80px">
                    <div v-if="index >= startIdx && index <= endIdx" class="div-table-row table-item" :ref="'pj' + index">
                        <!--        编码            -->
                        <div class="div-table-cell" style="width: 15%; flex-grow: 1" :class="{ 'check-code-class': item.CodeRepeat }">
                            <img src="../../../assets/images/info.png" alt title="配件信息" class="info-icon" @click="showAPMsgDialog(item.EntpTempGoodsId)" />
                            <el-select style="width: 100%" :ref="'code' + index" :disabled="dataReadonly" default-first-option size="small" v-model="item.APCode" value-key="APCode" filterable clearable remote reserve-keyword placeholder="汽配编码" @focus="hideMsg" @change="codeChange($event, index)" @visible-change="apCodeVisibleChange($event)" :remote-method="searchCode" v-select-scroll-more="searchCodeLoad">
                                <el-option v-for="optionItem in codeList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.APCode" :value="optionItem.EntpTempGoodsId">
                                    <div class="option-content">
                                        <div style="width: 200px">{{ optionItem.APCode }}</div>
                                        <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                        <div>{{ optionItem.AutoSerise }}</div>
                                    </div>
                                </el-option>
                                <el-option v-if="loading" disabled value style="text-align:center">
                                    加载中 <i class="el-icon-loading"></i>
                                </el-option>
                            </el-select>
                        </div>
                        <!--        名称            -->
                        <div class="div-table-cell" style="width: 20%">
                            <el-select ref="partsNameSelect" style="width: 100%" :disabled="dataReadonly" allow-create size="small" v-model="item.GoodName" filterable clearable remote reserve-keyword placeholder="配件名称" @focus="hideMsg" @change="nameChange($event, index)" @visible-change="apNameVisibleChange($event)" :remote-method="searchName" v-select-scroll-more="searchNameLoad">
                                <el-option v-for="optionItem in nameList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.GoodName" :value="optionItem.GoodName">
                                    <div class="option-content">
                                        <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                        <div style="width: 200px">{{ optionItem.APCode }}</div>
                                        <div>{{ optionItem.AutoSerise }}</div>
                                    </div>
                                </el-option>
                                <el-option v-if="loading" disabled value style="text-align:center">
                                    加载中 <i class="el-icon-loading"></i>
                                </el-option>
                            </el-select>
                        </div>
                        <!--        车系            -->
                        <div class="div-table-cell" style="width: 25%">
                            <el-select style="width: 100%" :disabled="dataReadonly" allow-create size="small" v-model="item.AutoSerise" filterable clearable remote reserve-keyword placeholder="车系" @focus="hideMsg" @visible-change="autoSeriseVisibleChange($event)" :remote-method="searchAutoSerie" v-select-scroll-more="searchAutoSerieLoad">
                                <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName"></el-option>
                                <el-option v-if="loading" disabled value style="text-align:center">
                                    加载中 <i class="el-icon-loading"></i>
                                </el-option>
                            </el-select>
                        </div>
                        <!--        数量            -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-input type="number" :ref="'count' + index" min="1" size="small" v-model="item.Count" @change="priceChange" @focus="hideMsg" :disabled="dataReadonly" @keyup.enter.native="addItem()"></el-input>
                        </div>
                        <!--        单位         -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-select :disabled="dataReadonly" default-first-option size="small" v-model="item.Unit" filterable clearable remote reserve-keyword placeholder="单位" @focus="hideMsg" @visible-change="unitVisibleChange($event)">
                                <el-option v-for="optionItem in unitList" :key="optionItem.TKey" :label="optionItem.TValue" :value="optionItem.TValue"></el-option>
                            </el-select>
                        </div>
                        <!--        成本价           -->
                        <div class="div-table-cell" style="width: 10%">
                            <el-input size="small" type="number" step="0.01" min="0" v-model="item.CostPrice" :disabled="dataReadonly" @focus="hideMsg" @keyup.enter.native="addItem()"></el-input>
                        </div>
                        <div class="div-table-cell" style="width: 10%">
                            {{ item.Inventory }}
                        </div>
                        <el-button class="less-btn" icon="el-icon-minus" circle @click="delItem(index)" v-if="!dataReadonly"></el-button>
                    </div>
                </div>
                <div class="infinite-loading" v-if="showInfiniteLoading">
                    <i class="el-icon-loading" />加载中
                </div>
                <div style="margin-right: 80px" v-else>
                    <div class="div-table-row table-item">
                        <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
                        <div class="div-table-cell" style="width: 20%"></div>
                        <div class="div-table-cell" style="width: 25%">总数量</div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                <span>{{ allNum }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%"></div>
                        <div class="div-table-cell" style="width: 10%">
                            <el-tooltip effect="dark" :content="allMoney.toFixed(3).toString()" placement="top">
                                <span>{{ allMoney.toFixed(3) }}</span>
                            </el-tooltip>
                        </div>
                        <div class="div-table-cell" style="width: 10%"></div>
                    </div>
                    <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem()" v-if="!dataReadonly"></el-button>
                </div>
            </div>
        </div>
    </div>
    <!--   搜索配件    -->
    <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
        <div v-if="searchVisible">
            <searchAP canEdit="canNot" :OnlyOneOption="OnlyOneOption" :IsGetNoSets="true" :SelectedData="selectedData" @closeDialog="closeSearchDialog" @chooseAllAPsHandle="chooseAllAPsHandle"></searchAP>
        </div>
    </el-dialog>
    <!--   配件信息     -->
    <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
        <div v-if="APMsgVisible">
            <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
        </div>
    </el-dialog>
    <!-- 进度条 -->
    <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
</div>
</template>

<script>
import breadcrumb from "@/components/common/breadcrumb";
import searchAP from "@/components/common/searchAP";
import APMsg from "@/components/common/APMsg";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    searchAP,
    APMsg,
    breadcrumb,
  },
  watch: {
    $route(to, from) {
      if (to === this.$route) {
        this.init();
      }
    },
    showSetMsg() {
      let topValue = document.getElementById("infinite-list").scrollTop;
      this.scrollPosition = topValue;
    },
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      OnlyOneOption: false,
      setId: "",
      setModel: {},
      userMsg: userMsg,
      EntpTempGoodsIdEdit: "",
      loading: false,
      dataReadonly: false,
      showSetMsg: true,
      APMsgVisible: false,
      searchVisible: false,
      allNum: 1,
      allMoney: 0,
      editIndex: -1,
      submitData: {
        StaffId: "",
        MainGoodsId: "",
        GoodName: "",
        AutoSerise: "",
        APCode: "",
        SetId: "",
        DetailList: [],
      },
      Limit: 10,
      codeList: [],
      nameList: [],
      seriesList: [],
      dataList: [],
      unitList: [],
      type: 0, //  1 查看 2 编辑 0 新增
      id: "",
      pageTitle: "",
      startIdx: 0, // 列表显示的第一个列的下标
      endIdx: 49, // 列表显示的最后一个列的下标
      stopLoad: false, // 停止监听上下滚动
      windowHeight: window.innerHeight,
      infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
      scrollPosition: 0, // 滚动条位置，用于判断是否收起信息栏
      selectedData: [],
      // 用于汽配编码列表，分页搜索功能
      codeForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 用于配件名称列表，分页搜索功能
      nameForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 用于车型列表，分页搜索功能
      autoSerieForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
      // 搜索配件弹框返回参数
      searchApParams: {
        _visible: false,
        _percentage: 0,
        _limit: 500,
        // 总数量
        _totalCount: 0,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  created() {
    document.addEventListener("keydown", this.handleKeyEvent);
  },
  mounted() {
    this.init();
    // 监听滚动事件
    document.addEventListener("scroll", this.loadTopScroll, true);
    window.onresize = () => {
      this.resetHeight();
    };
    // 给business-content强行写入css样式
    let bc = document.getElementsByClassName("business-content")[0];
    bc.style.overflow = "hidden";
    bc.style.scrollbarWidth = "none";
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadTopScroll, true);
    let bc = document.getElementsByClassName("business-content")[0];
    bc.style.overflow = "auto";
    bc.style.scrollbarWidth = "auto";
  },
  computed: {
    // 是否显示loading
    showInfiniteLoading() {
      return this.endIdx < this.dataList.length - 1;
    },
  },
  methods: {
    handleKeyEvent(e) {
      let key = window.event.keyCode;
      if (key === 107 || key === 187) {
        if (!this.searchVisible) this.addItem();
      }
      if (key == 113) {
        this.searchVisible = true;
      }
    },
    /**
     * 向上滚动
     * topValue: 距离顶部距离
     */
    loadTopScroll() {
      let topValue = document.getElementById("infinite-list").scrollTop;
      if (this.showSetMsg && topValue > this.scrollPosition) {
        this.scrollPosition = topValue;
        this.hideMsg();
      }
      if (topValue > 150 || this.stopLoad) return;
      this.stopLoad = true;
      if (this.startIdx > 0) {
        if (this.startIdx < 25) {
          let over = this.startIdx;
          this.startIdx -= Math.abs(over);
          this.endIdx -= Math.abs(over);
          this.$message({
            type: "info",
            offset: this.windowHeight / 2,
            message: "您现在在顶部",
          });
        } else if (this.startIdx >= 25) {
          this.startIdx -= 25;
          this.endIdx -= 25;
          if (this.startIdx === 0) {
            this.$message({
              type: "info",
              offset: this.windowHeight / 2,
              message: "您现在在顶部",
            });
          } else {
            // 对火狐浏览器做特殊处理
            if (navigator.userAgent.indexOf("Firefox") >= 0) {
              let sh =
                document.getElementById("infinite-list").scrollHeight / 4;
              document.getElementById("infinite-list").scrollTop = sh;
            }
          }
        }
      }
      this.stopLoad = false;
    },
    // 向下滚动
    loadDownScroll() {
      let listLastIndex = this.dataList.length - 1;
      if (listLastIndex < 50 || this.stopLoad) return;
      this.stopLoad = true;
      if (this.endIdx < listLastIndex) {
        if (this.endIdx + 25 <= listLastIndex) {
          this.startIdx += 25;
          this.endIdx += 25;
          if (this.endIdx === this.listLastIndex) {
            this.$message({
              type: "info",
              offset: this.windowHeight / 2,
              message: "您已经触底了哦~",
            });
          }
        } else {
          let over = this.endIdx;
          this.startIdx += listLastIndex - over;
          this.endIdx += listLastIndex - over;
          this.$message({
            type: "info",
            offset: this.windowHeight / 2,
            message: "您已经触底了哦~",
          });
        }
      }
      this.stopLoad = false;
    },
    // 计算infinite-list高度
    resetHeight() {
      let listObj = document.getElementById("infinite-list");
      if (!listObj) return;
      let clientObj = listObj.getBoundingClientRect();
      this.infiniteListHeight = window.innerHeight - clientObj.top;
    },
    init() {
      // let fullPath = this.$route.fullPath;
      // document.onkeydown = (event) => {
      //   if(fullPath == this.$route.fullPath&&this.type != 1){
      //   let e = event || window.event || arguments.callee.caller.arguments[0];
      //   if (e && e.keyCode == 13) this.addItem();
      //   }
      // };

      this.setId = this.$route.query.SetId;
      this.type = Number(this.$route.query.type);

      let setModel = "";
      let datalist = "";
      switch (this.type) {
        case 1:
          this.pageTitle = "查看套包详细";
          this.dataReadonly = true;
          this.getSetDetail();
          break;
        case 2:
          this.pageTitle = "编辑套包";
          this.dataReadonly = false;
          this.getSetDetail();
          break;
        case 0:
          this.pageTitle = "新增套包单";
          this.addItem();
          break;
        default:
          break;
      }
      setTimeout(() => {
        this.resetHeight();
      }, 0);
    },
    getConfigData() {
      this.$util.getConfigData("Unit").then((res) => {
        this.unitList = res;
      });
    },
    // 搜索
    showSearch(onlyOne) {
      this.OnlyOneOption = onlyOne;
      if (this.dataList.length > 0) {
        this.selectedData = [];
        this.dataList.forEach((item) => {
          if (item.EntpTempGoodsId)
            this.selectedData.push(item.EntpTempGoodsId);
        });
      }
      this.searchVisible = true;
    },
    // 搜索配件弹框 - 确认筛选结果按钮操作
    chooseAllAPsHandle(data) {
      this.searchVisible = false;
      this.searchApParams = {
        ...data.searchData,
        limit: this.searchApParams._limit,
        _visible: true,
        _percentage: 0,
        _limit: this.searchApParams._limit,
        _totalCount: data.searchData.limit,
      };
      this.loopSearch();
    },
    // 开始循环
    async loopSearch() {
      const { data } = await this.$util.axiosPost({
        url: "/api/EntpGoods/GetFullDataGoodsListForOrder",
        data: this.searchApParams,
        hideLoading: true,
      });
      this.searchApParams._percentage = parseInt(
        ((this.searchApParams.page * this.searchApParams.limit) /
          this.searchApParams._totalCount) *
          100
      );
      this.searchApParams.page += 1;
      let _stop = !data || data.length < this.searchApParams._limit;
      this.closeSearchDialog(data);
      if (_stop) {
        this.searchApParams._percentage = 100;
        this.searchApParams._visible = false;
      } else {
        this.loopSearch();
      }
    },
    closeSearchDialog(items) {
      if (this.OnlyOneOption) {
        //要检查一下这个是不是已经创建了包
        this.$util
          .axiosGet({
            url: "/api/EntpGoods/CheckGoodsSetsByAPCode",
            data: {
              APCode: items.APCode,
              EntpId: this.userMsg.EntpId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (!data) {
              this.submitData.APCode = items.APCode;
              this.submitData.GoodName = items.GoodName;
              this.submitData.AutoSerise = items.AutoSerise;
              this.submitData.MainGoodsId = items.EntpTempGoodsId;
            } else {
              this.$util.warningMsg(
                "该组包商品已经存在，请选择其他商品继续操作"
              );
            }
          });
      } else {
        let itemList = [...items];
        let tempList = [];
        if (this.dataList[0].APCode != "") {
          tempList = tempList.concat(this.dataList);
        }

        for (let i = 0; i < itemList.length; i++) {
          const item = itemList[i];
          let isConcat = false;
          for (let j = 0; j < this.dataList.length; j++) {
            const element = this.dataList[j];
            if (element.APCode == item.APCode) {
              isConcat = true;
              j = this.dataList.length;
            }
          }
          if (!isConcat) {
            let _data = {
              CostPrice: item.CostPrice ? item.CostPrice : 0,
              EntpTempGoodsId: item.EntpTempGoodsId,
              APCode: item.APCode,
              GoodName: item.GoodName,
              AutoSerise: item.AutoSerise,
              Count: 1,
              Unit: item.Unit,
              CodeRepeat: false,
              Inventory: item.Inventory,
            };
            tempList.push(_data);
          }
        }
        this.dataList = tempList;
        this.checkCodeRepeat();
      }
      this.priceChange();
      this.searchVisible = false;
    },
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog(edit) {
      this.APMsgVisible = false;
      if (edit) {
        this.getSetDetail();
      }
    },
    // 配件信息
    hideMsg() {
      this.showSetMsg = false;
      setTimeout(() => {
        this.resetHeight();
      }, 100);
    },
    showMsg() {
      this.showSetMsg = true;
      setTimeout(() => {
        this.resetHeight();
      }, 100);
    },
    checkCodeRepeat() {
      let repeatIndexs = [];
      let obj = {};
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        _dataList[i].CodeRepeat = false;
        if (!obj[_dataList[i].EntpTempGoodsId]) {
          obj[_dataList[i].EntpTempGoodsId] = [i];
        } else {
          obj[_dataList[i].EntpTempGoodsId].push(i);
        }
      }

      for (let key in obj) {
        if (obj[key].length >= 2 || this.submitData.EntpTempGoodsId == key) {
          repeatIndexs = [...repeatIndexs, ...obj[key]];
        }
      }
      for (let j = 0; j < repeatIndexs.length; j++) {
        this.dataList[repeatIndexs[j]].CodeRepeat = true;
      }
    },
    // 数量或者价格变动
    priceChange() {
      let DetailList = this.dataList;
      let _allNum = 0;
      let _allMoney = 0;
      for (let i = 0; i < DetailList.length; i++) {
        _allNum += Number(DetailList[i].Count);
        _allMoney += Number(
          DetailList[i].Count * DetailList[i].CostPrice
            ? (DetailList[i].Count * DetailList[i].CostPrice).toFixed(3)
            : 0
        );
      }
      this.allMoney = _allMoney;
      this.allNum = _allNum;
      this.dataList = DetailList;
    },
    // 获取详情
    getSetDetail() {
      this.$util
        .axiosGet({
          url: "/api/EntpGoods/GetEnterpriseGoodsSetDetails",
          data: {
            SetId: this.setId,
            EntpId: this.userMsg.EntpId,
          },
        })
        .then((res) => {
          let data = res.data;
          let DetailList = data.DetailList;
          this.submitData = data;
          let _allNum = 0;
          let _allMoney = 0;
          for (let i = 0; i < DetailList.length; i++) {
            _allNum += Number(DetailList[i].Count);
            _allMoney +=
              DetailList[i].Count * DetailList[i].CostPrice
                ? DetailList[i].Count * DetailList[i].CostPrice
                : 0;

            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
          }
        });
    },
    // 提交销售单
    submitForm() {
      let _dataList = this.dataList;
      if (!this.submitData.MainGoodsId) {
        this.$util.warningMsg("请选择设置的主包商品");
        this.showMsg();
        return;
      }
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if (!_dataList[i].AutoSerise) {
          this.$util.warningMsg("请填写车型");
          return;
        }
        if (!_dataList[i].Count || _dataList[i].Count < 0) {
          this.$util.warningMsg("请填写正确的数量");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
        if (this.submitData.MainGoodsId == _dataList[i].EntpTempGoodsId) {
          this.$util.warningMsg("组包的商品不能选择套包商品！");
          return;
        }
      }
      this.submitData.DetailList = _dataList;
      this.submit();
    },
    submit() {
      this.submitData.StaffId = this.userMsg.EmployeeId;
      this.submitData.SetId = this.setId;
      this.$util
        .axiosPost({
          url: "/api/EntpGoods/SaveEnterpriseGoodsSets",
          data: this.submitData,
        })
        .then((res) => {
          if (res.errcode == 0) {
            this.$util.successMsg(res.errmsg);

            this.$store.commit("updateNeedRefresh", true);
            setTimeout(() => {
              this.$router.push("/inventoryManage/goods/sets");
            }, 2000);
          }
        });
    },
    // 删除某行
    delItem(index) {
      if (this.dataList.length != 1) {
        this.dataList.splice(index, 1);
      }
      this.priceChange();
    },
    // 添加一行
    addItem() {
      let _dataList = this.dataList;
      for (let i = 0; i < _dataList.length; i++) {
        if (!_dataList[i].APCode) {
          this.$util.warningMsg("请填写配件编码");
          return;
        }
        if (!_dataList[i].GoodName) {
          this.$util.warningMsg("请填写配件名称");
          return;
        }
        if (!_dataList[i].AutoSerise) {
          this.$util.warningMsg("请填写车型");
          return;
        }
        if (!_dataList[i].Unit) {
          this.$util.warningMsg("请填写单位");
          return;
        }
      }

      this.dataList.push({
        Inventory: 0,
        EntpTempGoodsId: "",
        APCode: "",
        GoodName: "",
        AutoSerise: "",
        Count: "1",
        CostPrice: "0",
        Unit: "",
        CodeRepeat: false
      });

      // 当dataList数量大于50时
      if (this.dataList.length > 50) {
        this.startIdx += 1;
        this.endIdx += 1;
      }

      this.priceChange();
    },
    // 搜索汽配编码
    searchCode(key) {
      if (![undefined].includes(key)) {
        this.codeForm.Page = 1;
        this.codeForm.stopLoad = false;
        this.codeForm.key = key;
        this.codeList = [];
      }
      if (this.codeForm.stopLoad) return;
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder",
          data: {
            APCode: this.codeForm.key,
            Page: this.codeForm.Page,
            Limit: this.codeForm.Limit,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.loading = false;
          if (!res.data) return;
          this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
          this.codeList = this.$util.uniqueArr(this.codeList, res.data);
        });
    },
    // 汽配编码列表，加载更多
    searchCodeLoad() {
      this.codeForm.Page += 1;
      this.searchCode();
    },
    // 搜索名称
    searchName(key) {
      if (![undefined].includes(key)) {
        this.nameForm.Page = 1;
        this.nameForm.stopLoad = false;
        this.nameForm.key = key;
        this.nameList = [];
      }
      if (this.nameForm.stopLoad) return;
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder",
          data: {
            GoodName: this.nameForm.key,
            Page: this.nameForm.Page,
            Limit: this.nameForm.Limit,
          },
          hideLoading: true,
        })
        .then((res) => {
          this.loading = false;
          if (!res.data) return;
          this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
          this.nameList = this.$util.uniqueArr(this.nameList, res.data);
        });
    },
    // 汽配名称列表，加载更多
    searchNameLoad() {
      this.nameForm.Page += 1;
      this.searchName();
    },
    // 搜车系
    searchAutoSerie(key) {
      if (![undefined].includes(key)) {
        this.autoSerieForm.Page = 1;
        this.autoSerieForm.stopLoad = false;
        this.autoSerieForm.key = key;
        this.seriesList = [];
      }
      if (this.autoSerieForm.stopLoad) return;
      this.loading = true;
      this.$util
        .searchAutoSerie(
          this.autoSerieForm.key,
          this.autoSerieForm.Page,
          this.autoSerieForm.Limit
        )
        .then((data) => {
          this.loading = false;
          if (!data) return;
          this.autoSerieForm.stopLoad = data.length < this.autoSerieForm.Limit;
          this.seriesList = this.$util.uniqueArr(this.seriesList, data);
        });
    },
    // 车系列表，加载更多
    searchAutoSerieLoad() {
      this.autoSerieForm.Page += 1;
      this.searchAutoSerie();
    },
    // 名称改变
    nameChange(value, index) {
      this.editIndex = index;
      let _list = this.nameList;
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].GoodName == value) {
          if (!this.dataList[index].APCode) {
            this.dataList[index].APCode = _list[i].APCode;
            this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
          }
          this.dataList[index].CostPrice = _list[i].CostPrice;
          this.dataList[index].GoodName = _list[i].GoodName;
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
          this.dataList[index].Inventory = _list[i].Inventory;
        }
      }
      this.priceChange();
    },
    // 编码改变
    codeChange(value, index) {
      this.checkCodeRepeat();
      this.editIndex = index;
      let _list = this.codeList;
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].EntpTempGoodsId == value) {
          this.dataList[index].APCode = _list[i].APCode;
          this.dataList[index].CostPrice = _list[i].CostPrice;
          this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
          this.dataList[index].GoodName = _list[i].GoodName;
          this.dataList[index].Unit = _list[i].Unit;
          this.dataList[index].AutoSerise = _list[i].AutoSerise;
          this.dataList[index].Inventory = _list[i].Inventory;
        }
      }
      this.priceChange();
    },

    // 改变商品数量
    handleNumChange(data, value, index) {
      this.dataList[index].Count = value;
    },
    //单位下拉框显示时触发event
    unitVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.unitList.length == 0) that.getConfigData();
      }
    },
    //当汽配件编码下拉框出现时触发
    apCodeVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.codeList.length == 0) that.searchCode("");
      }
    },
    //当汽配件名称下拉框出现时触发
    apNameVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.nameList.length == 0) that.searchName("");
      }
    },
    //当车系下拉框出现时触发
    autoSeriseVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.seriesList.length == 0) that.searchAutoSerie("");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-bottom: 0px;
}

.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}

.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}

.search-ctn {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}

.option-content {
  display: flex;
  line-height: 30px;
}

.btn-ctn {
  padding: 30px 0;
  margin-right: 110px;
  text-align: right;
}

.add-btn {
  position: absolute;
  right: 2%;
  bottom: 0;
}

.less-btn {
  position: absolute;
  right: -40px;
  top: 2px;
  z-index: 2;
}

.table-main {
  position: relative;
}

.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}

.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}

.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-grow: 1;
}

.table-item {
  height: 50px;
  position: relative;
}

.div-table-row {
  overflow: inherit;
  margin: -1px -1px -1px 0px;
}
</style>
<style lang="less">
.check-code-class {
  .el-input__inner {
    border: 1px solid #f56c6c;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 20px;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
